/* eslint-disable no-restricted-imports */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import {
	BoldTextAttrSx,
	tileDescriptionSX,
	noMargin,
} from '@/components/content/ProductDetails/styles/attributes';
import { ProductDetailsSizesGuideDialog } from '@/components/blocks/ProductDetails/SizesGuideModal';
import { useDpDisclaimerSizeHandler } from '@/components/blocks/DpPdpDisclaimerSize';

export const BundleAttributes: FC = () => {
	const { on: openDrawerSizeGuide } = useDpDisclaimerSizeHandler();

	return (
		<>
			<Typography>
				<Typography sx={BoldTextAttrSx}>{'Las tallas son MX'}</Typography>
				<Typography sx={tileDescriptionSX}>
					{'(cm), consulta la'}
					<Linkable href="" type="inline" sx={noMargin} onClick={openDrawerSizeGuide}>
						{'Guía de tallas'}
					</Linkable>
					{' y compara tallas nacionales'}
				</Typography>
			</Typography>
			<ProductDetailsSizesGuideDialog />
		</>
	);
};
